import { Skeleton, Box, Flex } from '@chakra-ui/react';
import React from 'react';
import './styles.scss';

const HeadSkeleton = () => (
    <Flex className="head-skeleton__stock-trail">
        <Flex alignItems="center">
            <Box className="search-filter">
                <Skeleton
                    className="stock-trail__skeleton-head"
                    height="28px"
                    w="240px"
                    borderRadius="4px"
                    startColor="var(--main-color-light-active)"
                    endColor={`rgba(var(--main-color),0.5)`}
                    mr="8px"
                />
                <Skeleton
                    className="stock-trail__skeleton-head"
                    height="28px"
                    w="48px"
                    borderRadius="4px"
                    startColor="var(--main-color-light-active)"
                    endColor={`rgba(var(--main-color),0.5)`}
                />
            </Box>

            <Box className="filter">
                <Skeleton
                    className="stock-trail__skeleton-head"
                    height="28px"
                    w="84px"
                    borderRadius="4px"
                    startColor="var(--main-color-light-active)"
                    endColor={`rgba(var(--main-color),0.5)`}
                    mr="8px"
                />
                <Skeleton
                    className="stock-trail__skeleton-head"
                    height="28px"
                    w="28px"
                    borderRadius="4px"
                    startColor="var(--main-color-light-active)"
                    endColor={`rgba(var(--main-color),0.5)`}
                />
            </Box>
            <Box className="filter">
                <Skeleton
                    className="stock-trail__skeleton-head"
                    height="28px"
                    w="84px"
                    borderRadius="4px"
                    startColor="var(--main-color-light-active)"
                    endColor={`rgba(var(--main-color),0.5)`}
                    mr="8px"
                />
                <Skeleton
                    className="stock-trail__skeleton-head"
                    height="28px"
                    w="28px"
                    borderRadius="4px"
                    startColor="var(--main-color-light-active)"
                    endColor={`rgba(var(--main-color),0.5)`}
                />
            </Box>
        </Flex>
        <Flex alignItems="center">
            <Box className="add-button">
                <Skeleton
                    className="stock-trail__skeleton-head"
                    height="28px"
                    w="48px"
                    borderRadius="4px"
                    startColor="var(--main-color)"
                    endColor={`rgba(var(--main-color),0.5)`}
                    mr="8px"
                />
                <Skeleton
                    className="stock-trail__skeleton-head"
                    height="28px"
                    w="240px"
                    borderRadius="4px"
                    startColor="var(--main-color)"
                    endColor={`rgba(var(--main-color),0.5)`}
                />
            </Box>
            <Skeleton
                className="stock-trail__skeleton-head"
                height="28px"
                w="16px"
                borderRadius="4px"
                startColor="var(--main-color)"
                endColor={`rgba(var(--main-color),0.5)`}
            />
        </Flex>
    </Flex>
);

export default HeadSkeleton;
